// import ToolTip from '../components/ToolTip';
// import {
//   Link
// } from "react-router-dom";
// import RevealOnScroll from '../components/RevealOnScroll';
// import HoverBox from '../components/HoverBox';
import React from 'react';
import vjBlackhawks from '../images/familyphotos/virgiljohnson_blackhawks_1938.jpg';
import {
  PageContent,
  ContentBox
} from '../css/_styledComponents';

function Home () {
  return (
    <PageContent>
      <ContentBox type="white">
        <figure style={{ float: 'left' }}>
          <img src={vjBlackhawks} alt="Virgil Johnson 1938" />
          <figcaption>Virgil Johnson Chicago Black Hawks 1938</figcaption>
        </figure>
        <div>
          <h1>Virgil Johnson 1909 - 1993</h1>
          <ul>
            <li>Inducted into the US Hockey Hall of Fame in 1974.</li>
            <li>
              Member of the Chicago Black Hawks (NHL) &quot;Cinderella Team&quot;
              winners of the Stanley Cup in 1937-1938.
            </li>
            <li>Played for the Minneapolis Millers (CHL/USHL), St. Paul Saints (CHL/AHA/AAHL), Hershey Bears (AHL) and Cleveland Barons (AHL).</li>
            <li>Voted &quot;most valuable player&quot; for the St. Paul Saints (AHA) in 1942.</li>
            <li>
              Retired from the rink in 1952 after 22 years playing and coaching professional hockey.
            </li>
          </ul>
        </div>
      </ContentBox>
    </PageContent>
  );
}

export default Home;
